import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { fetchUpcomingEvents, type CalendarEventItem } from '../../../lib/calendarApi';

function fmt(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('ro-RO', { month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export default function AppointmentsCard() {
  const navigate = useNavigate();
  const [items, setItems] = useState<CalendarEventItem[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      try {
        const data = await fetchUpcomingEvents(5);
        if (!cancelled) setItems(data);
      } catch {
        if (!cancelled) setItems([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    void load();
    const t = window.setInterval(() => void load(), 60_000);
    return () => {
      cancelled = true;
      window.clearInterval(t);
    };
  }, []);

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="CalendarDays" size={20} className="text-muted-foreground" />
          <h2 className="text-lg font-semibold text-foreground">Programări</h2>
        </div>
        <Button variant="ghost" size="sm" iconName="ExternalLink" onClick={() => navigate('/calendar')}>
          Vezi calendar
        </Button>
      </div>

      {loading ? (
        <div className="text-sm text-muted-foreground">Se incarca...</div>
      ) : items.length === 0 ? (
        <div className="text-sm text-muted-foreground">Nu exista programari viitoare.</div>
      ) : (
        <div className="space-y-3">
          {items.map((e) => (
            <div key={e.id} className="flex items-start gap-3 p-3 bg-muted/30 rounded-md">
              <div className="flex-shrink-0 mt-0.5">
                <Icon name="Clock" size={16} className="text-muted-foreground" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-medium text-foreground truncate">{e.title}</div>
                <div className="text-xs text-muted-foreground mt-1">
                  {fmt(e.start_time)} → {fmt(e.end_time)}
                </div>
              </div>
              <span className="text-xs px-2 py-0.5 rounded bg-muted text-foreground whitespace-nowrap">
                {e.event_type || 'Altul'}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
